import { useState, useEffect } from 'react';
import { Row, Col, Tabs, Button, Form, DatePicker, Input, Select, message } from 'antd';
import ReservationsToBill from './components/ReservationsToBill';
import BilledReservations from './components/BilledReservations';
import ReservationsToBillWithItems from './components/ReservationsToBillWithItems';
import { generalInvoiceService } from '../services/generalInvoice';
import invoiceService from '../services/invoiceService';
import { exportBillingReportToExcel } from '../utils/excelUtils';
import locale from 'antd/es/date-picker/locale/es_ES';
import moment from 'moment';
import Cookies from 'universal-cookie';

const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { format } = require('rut.js');

const GeneralInvoicePage = () => {
   const cookies = new Cookies();
   const roles = cookies.get('roles') || [];
   const isContabilidad = roles.includes('contabilidad');
   const [filters, setFilters] = useState({
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD')
   });
   const [paymentMethods, setPaymentMethods] = useState();
   const [providerPaymentMethods, setProviderPaymentMethods] = useState();
   const [activeTab, setActiveTab] = useState('1');
   const [branchOffices, setBranchOffices] = useState();
   const [id, setId] = useState(Math.random());
   const [downloading, setDownloading] = useState(false);
   const [form] = Form.useForm();

   const isBilledTab = activeTab === '2';

   const fetchPaymentMethods = async () => {
      const response = await generalInvoiceService.paymentMethods();
      setPaymentMethods(response);
   };

   const fetchProviderPaymentMethods = async () => {
      const response = await invoiceService.fetchExternalPaymentMethods({});
      setProviderPaymentMethods(response);
   };

   const onTabChange = (key) => {
      setActiveTab(key);
      form.setFieldsValue({ paymentMethod: undefined });
   };

   const fetchBranchOfficesByAdmin = async () => {
      const response = await generalInvoiceService.branchOfficesByAdmin();
      setBranchOffices(response);
      
      if (isContabilidad) {
         form.setFieldsValue({
            branchOffice: ''
         });
      } else if (response && response.length > 0) {
         setFilters(prev => ({ ...prev, branchOffice: response[0]['id'] }));
         form.setFieldsValue({
            branchOffice: response[0]['id']
         });
      }
   }

   useEffect(() => {
      fetchBranchOfficesByAdmin();
      fetchPaymentMethods();
      fetchProviderPaymentMethods();
      form.setFieldsValue({
         date: [
            moment(filters.startDate, 'YYYY-MM-DD'),
            moment(filters.endDate, 'YYYY-MM-DD'),
         ]
      })
   }, []);

   const refreshData = () => {
      setId(Math.random())
   }

   const onFinish = values => {
      const params = {
         startDate: values.date && values.date[0].format('YYYY-MM-DD'),
         endDate: values.date && values.date[1].format('YYYY-MM-DD'),
         reservationNumber: values.reservationNumber,
         paymentMethod: isBilledTab ? undefined : values.paymentMethod,
         providerPaymentMethod: isBilledTab ? values.paymentMethod : undefined,
         branchOffice: values.branchOffice
      };

      if (values.document) {
         params['document'] = values.document;
      }

      const cleanedParams = Object.fromEntries(
         Object.entries(params).filter(([_, v]) => v !== undefined && v !== null && v !== '')
      );

      setFilters(cleanedParams);
   };

   const formatRutInput = event => {
      const formatRut = format(event.target.value);
      form.setFieldsValue({ rut: formatRut });
   };

   const download = async () => {
      const params = {
         branchOffice: filters.branchOffice,
         startDate: filters.startDate,
         endDate: filters.endDate,
         paymentMethod: filters.paymentMethod,
         reservationNumber: filters.reservationNumber
      };

      const cleanedParams = Object.fromEntries(
         Object.entries(params).filter(([_, v]) => v !== undefined && v !== null && v !== '')
      );

      setDownloading(true);

      try {
         const reportData = await generalInvoiceService.fetchBillingReport(cleanedParams);
         await exportBillingReportToExcel(reportData, cleanedParams);
      } catch (error) {
         console.error('error:', error);
         message.error('No se pudo descargar el reporte');
      } finally {
         setDownloading(false);
      }
   }

   return (
      <Row justify="center">
         <Col lg={24} xs={24} className="mt-30">
            <Row justify="start">
               <Col lg={24} xs={24}>
                  <h1>Facturador general</h1>
               </Col>
               <Col lg={24} xs={24}>
                  <Form
                     form={form}
                     layout="vertical"
                     onFinish={onFinish}
                     style={{ width: '100%' }}
                     size="large"
                  >
                     <Row justify="start" align="bottom" gutter={15}>
                        <Col lg={5} xs={24}>
                           <Form.Item label="Fecha" name="date" className="mb-0">
                              <RangePicker locale={locale} placeholder={['Desde', 'Hasta']} picker="date" />
                           </Form.Item>
                        </Col>
                        <Col lg={3} xs={24}>
                           <Form.Item name="reservationNumber" className="mb-0">
                              <Input placeholder="N° de reserva" />
                           </Form.Item>
                        </Col>
                        <Col lg={4} xs={24}>
                           <Form.Item name="document" className="mb-0" onChange={formatRutInput}>
                              <Input placeholder="N° de Documento empresa" />
                           </Form.Item>
                        </Col>
                        <Col lg={4} xs={24}>
                           <Form.Item name="branchOffice" className="mb-0">
                              <Select placeholder="Sucursal">
                                 {isContabilidad && <Select.Option value="">Todas las sucursales</Select.Option>}
                                 {
                                    branchOffices && branchOffices.map(branchOffice => {
                                       return <Select.Option key={branchOffice.id} value={branchOffice.id}>{branchOffice.name}</Select.Option>
                                    })
                                 }
                              </Select>
                           </Form.Item>
                        </Col>
                        <Col lg={4} xs={24}>
                           <Form.Item name="paymentMethod" className="mb-0">
                              <Select placeholder="Método de pago">
                                 {
                                    isBilledTab
                                       ? providerPaymentMethods && providerPaymentMethods.map(payment => {
                                          return <Select.Option key={payment.id} value={payment.id}>{payment.name}</Select.Option>
                                       })
                                       : paymentMethods && paymentMethods.map(payment => {
                                          return <Select.Option key={payment.id} value={payment.id}>{payment.name}</Select.Option>
                                       })
                                 }
                              </Select>
                           </Form.Item>
                        </Col>
                        <Col lg={4} xs={24}>
                           <Button htmlType="submit" type="primary" block>Buscar</Button>
                        </Col>
                     </Row>
                  </Form>
               </Col>
            </Row>
            <Row justify="center" className="mt-60">
               <Col lg={24} xs={24}>
                  {
                     (isContabilidad || filters['branchOffice']) &&
                     <Tabs defaultActiveKey="1" onChange={onTabChange}>
                        <TabPane tab="Reservas por facturar" key="1">
                           <ReservationsToBill filters={filters} refreshData={refreshData} id={id} />
                        </TabPane>
                        <TabPane tab="Reservas facturadas" key="2">
                           <BilledReservations filters={filters} />
                        </TabPane>
                        <TabPane tab="Reservas por facturar con nuevos ítems" key="3">
                           <ReservationsToBillWithItems filters={filters} refreshData={refreshData} id={id} />
                        </TabPane>
                     </Tabs>
                  }

               </Col>
            </Row>
            <Row justify="end" className="mb-40">
               <Col>
                  <Button
                     type="primary"
                     onClick={download}
                     loading={downloading}
                     disabled={!filters.branchOffice}
                  >
                     Descargar Reporte
                  </Button>
               </Col>
            </Row>
         </Col>
      </Row>
   );
};

export default GeneralInvoicePage;